import React from 'react';
import $ from 'jquery';
import PropTypes from 'prop-types';

import {
    Button,
} from 'react-bootstrap';

export default class ActionButton extends React.Component {

    constructor(props){
        super(props);
        this.state = {};
    }

    onActionClick = (url) => {
        $.ajax({
            url: url,
            dataType: 'json',
            headers: {'Authorization': 'Token ' + localStorage.token},
            cache: false,
            success: (data) => {
              this.props.setMessage(this.props.message);
            },
            error: (xhr, status, err) => {}
        });
    }

    render() {
        return (
            <Button bsStyle={this.props.bsStyle} block={this.props.block} style={this.props.button_style} bsSize={this.props.button_size} onClick={() => this.onActionClick(this.props.url)}>{this.props.title}</Button>
        );
    }
}

ActionButton.propTypes = {
    button_size: PropTypes.node,
    url: PropTypes.node,
    title: PropTypes.node,
    button_style: PropTypes.node,
    bsStyle: PropTypes.node,
};



// WEBPACK FOOTER //
// ./src/components/helpers/button/action_button.js